export default __webpack_public_path__ + "static/media/side-menu.979d22c7.svg";